import { sendAnalyticsEvent } from '@faststore/sdk'
import { useState } from 'react'
import { ArrowDownFooter } from 'src/components/icons/ArrowDownFooter'
import { FooterClick } from 'src/sdk/analytics/types'
import { FooterItem, FooterSubItem } from './SiteSections'

type SiteSectionItemProps = {
  item: FooterItem
  index: number
}

export const SiteSectionItem = ({ item, index }: SiteSectionItemProps) => {
  const [openSection, setOpenSection] = useState(false)

  const handleClick = (category: string = '', subcategory: string = '') => {
    if (!category || !subcategory) return

    sendAnalyticsEvent<FooterClick>({
      name: 'footer',
      params: {
        click_area: category,
        link_clicked: subcategory,
      },
    })
  }

  if (!item) return null

  return (
    <div
      key={index}
      className={`px-6 md:px-10 lg:px-0 py-4 lg:py-8 text-white flex-1 lg:flex-[0.19] 2xl:flex-[0.20] footer-accordion-js ${
        openSection ? 'open' : ''
      }`}
    >
      <button
        className="flex text-white py-1 gap-[10px] lg:mb-2 lg:h-[40px] lg:line-clamp-2 justify-between w-full lg:pointer-events-none footer-accordion-toggle-js bg-transparent"
        style={{ color: item.titleColor }}
        onClick={() => setOpenSection(!openSection)}
      >
        <span className="block w-full text-base xs:text-lg font-semibold !leading-[120%] tracking-[0.08px] xs:tracking-[0.024px] text-left  lg:text-sm lg-tracking-[0.035px]">
          {item.title}
        </span>
        <span
          className={`block min-h-[24px] min-w-[24px] lg:hidden transition-transform ${
            openSection ? 'rotate-180' : ''
          }`}
        >
          <ArrowDownFooter />
        </span>
      </button>
      <div className="footer-accordion-body-js">
        <div className="flex flex-col mt-5 lg:mt-0 gap-4 lg:gap-3">
          {item.items?.map((el: FooterSubItem, index: number) => {
            let color = el.labelColor
            return (
              <a
                key={`footer-item-${index}`}
                href={el.labelURL}
                className={`block w-full font-normal  tracking-[0.035px] text-sm !leading-[120%] xs:text-base xs:tracking-[0.08px] px-2 lg:text-xs no-underline hover:underline`}
                style={{ color: color }}
                onClick={() => handleClick(item.title, el.label)}
              >
                {el.label}
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}
